/**
 * @Author: kunnisser
 * @Date: 2020-07-15 10:46:25
 * @LastEditors: kunnisser
 * @LastEditTime: 2021-08-13 09:37:21
 * @FilePath: /app_h5/src/router/index.js
 * @Description: ---- 路由设置 ----
 */
import Vue from "vue";
import Router from "vue-router";

const CallCenter = () => import('@/pages/callCenter.vue')
const StationMap = () => import('@/pages/map')
const UserOrder = () => import('@/pages/order')
const PaymentDesc = () => import('@/pages/paymentDesc/index.vue')
const Guide = () => import('@/pages/guide/index')
const GuideNew = () => import('@/pages/guide/indexNew')
const AntForsetDesc = () => import('@/pages/antForsetDesc')
const InstantCharge = () => import('@/pages/instantCharge/index.vue')
const InstantCharge2 = () => import('@/pages/instantCharge/index2.vue')
const UserRights = () => import('@/pages/user/rights/index.vue')
const UserRightsDetail = () => import('@/pages/user/rights/detail.vue')
const UserIntegral = () => import('@/pages/user/integral.vue')
const Activity = () => import('@/pages/activity/index')
const couponDesc = () => import('@/pages/coupon/index')
const wiosScore = () => import('@/pages/wiosScore/index.vue')
const wiosScoreDetail = () => import('@/pages/wiosScore/detail.vue')
const placeHolderDesc = () => import('@/pages/placeHolder/index.vue')
const stationIntroduction = () => import('@/pages/stationIntroduction/index.vue')
const v1gInfo = () => import('@/pages/v1g/index.vue')
const v1gSelect = () => import('@/pages/v1g/selectStub.vue')
const v1gDesc = () => import('@/pages/v1g/desc.vue')
const couponDetail = () => import('@/pages/couponDetail/couponDetail.vue')
const couponStation = () => import('@/pages/couponDetail/couponStation.vue')
const balanceRefund = () => import('@/pages/balanceRefund/balanceRefund.vue')
const refundRecord = () => import('@/pages/balanceRefund/refundRecord.vue')
const refundDetail = () => import('@/pages/balanceRefund/refundDetail.vue')
const purchaseStub = () => import('@/pages/privateStation/purchaseStub.vue')
const activateMember = () => import('@/pages/member/activateMember.vue')
const memberBenefits = () => import('@/pages/member/memberBenefits.vue')
const exchangeMember = () => import('@/pages/member/exchangeMember.vue')
const memberManage = () => import('@/pages/member/memberManage.vue')
const associateMember = () => import('@/pages/member/associateMember/associateMember.vue')
const openAssociate = () => import('@/pages/member/associateMember/openAssociate.vue')
const thirdEquityCenter = () => import('@/pages/member/thirdEquity/thirdEquityCenter.vue')
const thirdEquityDetail = () => import('@/pages/member/thirdEquity/thirdEquityDetail.vue')
const benefitsLifeVouncher = () => import('@/pages/member/benefitsLifeVouncher.vue')
const appLinkPage = () => import('@/pages/member/appLinkPage.vue')
const v1gDetail = () => import('@/pages/v1g/detail.vue')
const privateStationGuide = () => import('@/pages/privateStation/guide.vue')
const privateStationChargeGuide = () => import('@/pages/privateStation/chargeGuide.vue')
const privateStationFamilyGuide = () => import('@/pages/privateStation/familyGuide.vue')
const hpcIndex = () => import('@/pages/hpc/index.vue')
const hpcInfo = () => import('@/pages/hpc/info.vue')
const hpcActivity = () => import('@/pages/hpc/activity.vue')
const hpcUserService = () => import('@/pages/hpc/service.vue')
const v1gStubInfo = () => import('@/pages/v1g/stub/index.vue')
const v1gStubSelect = () => import('@/pages/v1g/stub/selectStub.vue')
const v1gStubDesc = () => import('@/pages/v1g/stub/desc.vue')
const privateStationBluetoothGuide = () => import('@/pages/privateStation/bluetoothGuide.vue')
const chargingLine = () => import('@/pages/chargingLine/chargingLine.vue')
const digitalCCB = () => import('@/pages/digitalCCB/digitalCCB.vue')
const signEcny = () => import('@/pages/digitalCCB/signEcny.vue')
const inviteToGroup = () => import('@/pages/inviteToGroup/index.vue')
const verifyTruth = () => import('@/pages/verifyTruth/verifyTruth.vue')
const deviceRepair = () => import('@/pages/selfService/deviceRepair.vue')
const orderFroceStop = () => import('@/pages/selfService/orderFroceStop.vue')
const orderFroceStopDetail = () => import('@/pages/selfService/orderFroceStopDetail.vue')
const parkingFeeAppeal = () => import('@/pages/selfService/parkingFeeAppeal.vue')
const parkingFeeAppealDetail = () => import('@/pages/selfService/parkingFeeAppealDetail.vue')
const parkingFeeAppealFeedback = () => import('@/pages/selfService/parkingFeeAppealFeedback.vue')
const placeFeeAppeal = () => import('@/pages/selfService/placeFeeAppeal.vue')
const placeFeeAppealDetail = () => import('@/pages/selfService/placeFeeAppealDetail.vue')
const placeFeeAppealFeedback = () => import('@/pages/selfService/placeFeeAppealFeedback.vue')
const workOrderProgress = () => import('@/pages/selfService/workOrderProgress.vue')
const workOrderProgressDetail = () => import('@/pages/selfService/workOrderProgressDetail.vue')
const orderListSelect = () => import('@/pages/selfService/orderListSelect.vue')
const orderCouponDetail = () => import('@/pages/selfService/orderCouponDetail.vue')
const unableDrawGun = () => import('@/pages/selfService/unableDrawGun.vue')
const unableDrawGunVideo = () => import('@/pages/selfService/unableDrawGunVideo.vue')
const stationPrice = () => import('@/pages/selfService/stationPrice.vue')
const parkingFeeDetail = () => import('@/pages/selfService/parkingFeeDetail.vue')
const msgToApp = () => import('@/pages/msgToApp/index.vue')
const msgToWxMini = () => import('@/pages/msgToWxMini/index.vue')
const v1gStubInfoNew = () => import('@/pages/v1g/stub/info.vue')
const msgToLink = () => import('@/pages/msgToLink/index.vue')
const invoiceRule = () => import('@/pages/invoice/index.vue')
const firstChargeGift = () => import('@/pages/firstChargeGift/firstChargeGift.vue')
const monthStatics = () => import('@/pages/privateStation/monthStatics.vue')
const v1gOrderDetail = () => import('@/pages/v1g/orderDetail.vue')
const starStationDesc = () => import('@/pages/starStationDesc/starStationDesc.vue')
const newTechnologiesIntroduction = () => import('@/pages/newTechnologiesIntroduction/newTechnologiesIntroduction.vue')
const silentLockRelease = () => import('@/pages/newTechnologiesIntroduction/silentLockRelease.vue')
const accelerateCharge = () => import('@/pages/newTechnologiesIntroduction/accelerateCharge.vue')
const ninetyEightCharge = () => import('@/pages/newTechnologiesIntroduction/ninetyEightCharge.vue')
const accelerateStartup = () => import('@/pages/newTechnologiesIntroduction/accelerateStartup.vue')
const v2gDischarge = () => import('@/pages/newTechnologiesIntroduction/v2gDischarge.vue')
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "首页",
      component: CallCenter,
      meta: {
        title: "客服中心",
        keepAlive: true
      }
    },
    {
      path: "/callcenter",
      name: "客服中心",
      component: CallCenter,
      meta: {
        title: "客服中心",
        keepAlive: true
      }
    },
    {
      path: "/order",
      name: "用户订单",
      component: UserOrder,
      meta: {
        title: "用户订单"
      }
    },
    {
      path: "/map",
      name: "查找桩位",
      component: StationMap,
      meta: {
        title: "查找桩位"
      }
    },
    {
      path: "/paymentDesc",
      name: "支付方式说明",
      component: PaymentDesc,
      meta: {
        title: "支付方式说明"
      }
    },
    {
      path: "/guide",
      name: "新手指南",
      component: Guide,
      meta: {
        title: "新手指南"
      }
    },
    {
      path: "/guideNew",
      name: "新手指南新",
      component: GuideNew,
      meta: {
        title: "新手指南"
      }
    },
    {
      path: "/instantCharge",
      name: "即插即充",
      component: InstantCharge2,
      meta: {
        title: "即插即充"
      }
    },
    {
      path: "/antForsetDesc",
      name: "蚂蚁森林能量攻略",
      component: AntForsetDesc,
      meta: {
        title: "蚂蚁森林能量攻略"
      }
    },
    {
      path: "/user/rights",
      name: "我的权益",
      component: UserRights,
      meta: {
        title: "我的权益",
        keepAlive: true
      }
    },
    {
      path: "/user/rights/detail",
      name: "权益详情",
      component: UserRightsDetail,
      meta: {
        title: "权益详情",
        keepAlive: true
      }
    },
    {
      path: "/user/integral",
      name: "积分规则",
      component: UserIntegral,
      meta: {
        title: "积分规则"
      }
    },
    {
      path: "/activity",
      name: "开迈斯充电",
      component: Activity,
      meta: {
        title: "开迈斯充电"
      }
    },
    {
      path: "/couponDesc",
      name: "卡券使用说明",
      component: couponDesc,
      meta: {
        title: "卡券使用说明"
      }
    },
    {
      path: "/score",
      name: "安装评价",
      component: wiosScore,
      meta: {
        title: "安装评价"
      }
    },
    {
      path: "/scoreDetail",
      name: "安装评价详情",
      component: wiosScoreDetail,
      meta: {
        title: "安装评价"
      }
    },
    {
      path: "/placeHolderDesc",
      name: "超时占位说明",
      component: placeHolderDesc,
      meta: {
        title: "超时占位说明"
      }
    },
    {
      path: "/stationIntroduction",
      name: "开迈斯充电介绍",
      component: stationIntroduction,
      meta: {
        title: "开迈斯充电"
      }
    },
    {
      path: "/v1g/select",
      name: "参与电桩选择",
      component: v1gSelect,
      meta: {
        title: "参与电桩选择",
        keepAlive: true
      }
    },
    {
      path: "/v1g/desc",
      name: "智能充电管家v1gDesc",
      component: v1gDesc,
      meta: {
        title: "智能充电管家"
      }
    },
    {
      path: "/couponDetail",
      name: "卡券详情",
      component: couponDetail,
      meta: {
        title: "卡券详情",
        keepAlive: true
      }
    },
    {
      path: "/couponStation",
      name: "适用电站",
      component: couponStation,
      meta: {
        title: "适用电站"
      }
    },
    {
      path: "/balanceRefund",
      name: "余额退款",
      component: balanceRefund,
      meta: {
        title: "余额退款",
        keepAlive: true
      }
    },
    {
      path: "/balanceRefund/refundRecord",
      name: "退款记录",
      component: refundRecord,
      meta: {
        title: "退款记录",
        keepAlive: true
      }
    },
    {
      path: "/balanceRefund/refundDetail",
      name: "退款明细",
      component: refundDetail,
      meta: {
        title: "退款明细",
        keepAlive: true
      }
    },
    {
      path: "/purchase/stub",
      name: "购买私桩",
      component: purchaseStub,
      meta: {
        title: "购买私桩"
      }
    },
    {
      path: "/member/activateMember",
      name: "开通会员",
      component: activateMember,
      meta: {
        title: "开通会员",
        keepAlive: true
      }
    },
    {
      path: "/member/memberBenefits",
      name: "会员中心",
      component: memberBenefits,
      meta: {
        title: "会员中心",
        keepAlive: true
      }
    },
    {
      path: "/member/exchangeMember",
      name: "兑换会员",
      component: exchangeMember,
      meta: {
        title: "兑换会员"
      }
    },
    {
      path: "/member/memberManage",
      name: "会员管理",
      component: memberManage,
      meta: {
        title: "会员管理",
        keepAlive: true
      }
    },
    {
      path: "/member/associateMember",
      name: "开迈斯联合会员",
      component: associateMember,
      meta: {
        title: "开迈斯联合会员",
        keepAlive: true
      }
    },
    {
      path: "/member/openAssociate",
      name: "开通联合会员",
      component: openAssociate,
      meta: {
        title: "开通联合会员",
        keepAlive: true
      }
    },
    {
      path: "/member/thirdEquityCenter",
      name: "第三方权益中心",
      component: thirdEquityCenter,
      meta: {
        title: "第三方权益中心",
        keepAlive: true
      }
    },
    {
      path: "/member/thirdEquity/detail",
      name: "已领取权益详情",
      component: thirdEquityDetail,
      meta: {
        title: "已领取权益详情",
        keepAlive: true
      }
    },
    {
      path: "/member/benefitsLifeVouncher",
      name: "商超体验券",
      component: benefitsLifeVouncher,
      meta: {
        title: "商超体验券",
        keepAlive: true
      }
    },
    {
      path: "/member/appLinkPage",
      name: "外链",
      component: appLinkPage,
      meta: {
        title: ""
      }
    },
    {
      path: "/v1g/detail",
      name: "智能充电管家v1gDetail",
      component: v1gDetail,
      meta: {
        title: "智能充电管家"
      }
    },
    {
      path: "/private/guide",
      name: "使用指南",
      component: privateStationGuide,
      meta: {
        title: "使用指南"
      }
    },
    {
      path: "/private/guide/charge",
      name: "私桩如何充电",
      component: privateStationChargeGuide,
      meta: {
        title: "私桩如何充电"
      }
    },
    {
      path: "/private/guide/family",
      name: "如何添加家庭成员",
      component: privateStationFamilyGuide,
      meta: {
        title: "如何添加家庭成员"
      }
    },
    {
      path: "/hpc/index",
      name: "开迈斯闪充竞速赛",
      component: hpcIndex,
      meta: {
        title: "开迈斯闪充竞速赛",
        keepAlive: true
      }
    },
    {
      path: "/hpc/rank/info",
      name: "榜单规则",
      component: hpcInfo,
      meta: {
        title: "榜单规则"
      }
    },
    {
      path: "/hpc/activity/info",
      name: "活动规则",
      component: hpcActivity,
      meta: {
        title: "活动规则"
      }
    },
    {
      path: "/hpc/user/service",
      name: "开迈斯闪充竞速赛活动协议",
      component: hpcUserService,
      meta: {
        title: "开迈斯闪充竞速赛活动协议"
      }
    },
    {
      path: "/v1g/stub/index",
      name: "智能充电管家v1gStubInfo",
      component: v1gStubInfo,
      meta: {
        title: "智能充电管家",
        keepAlive: true
      }
    },
    {
      path: "/v1g/stub/select",
      name: "智能充电管家v1gStubSelect",
      component: v1gStubSelect,
      meta: {
        title: "智能充电管家",
        keepAlive: true
      }
    },
    {
      path: "/v1g/stub/desc",
      name: "智能充电管家v1gStubDesc",
      component: v1gStubDesc,
      meta: {
        title: "智能充电管家"
      }
    },
    {
      path: "/v1g/info",
      name: "智能充电管家v1gInfo",
      component: v1gInfo,
      meta: {
        title: "智能充电管家",
        keepAlive: true
      }
    },
    {
      path: "/private/guide/bluetooth",
      name: "蓝牙智控如何使用",
      component: privateStationBluetoothGuide,
      meta: {
        title: "蓝牙智控如何使用"
      }
    },
    {
      path: "/chargingLine",
      name: "充电参数",
      component: chargingLine,
      meta: {
        title: "充电参数"
      }
    },
    {
      path: "/digitalCCB",
      name: "签约详情",
      component: digitalCCB,
      meta: {
        title: "签约详情"
      }
    },
    {
      path: "/pay/signEcny",
      name: "成功签约",
      component: signEcny,
      meta: {
        title: "成功签约"
      }
    },
    {
      path: "/inviteToGroup",
      name: "成功签约群聊",
      component: inviteToGroup,
      meta: {
        title: "邀请入群"
      }
    },
    {
      path: "/verifyTruth",
      name: "电量验真",
      component: verifyTruth,
      meta: {
        title: "电量验真"
      }
    },
    {
      path: "/selfService/deviceRepair",
      name: "设备报修",
      component: deviceRepair,
      meta: {
        title: "设备报修",
        keepAlive: true
      }
    },
    {
      path: "/selfService/orderFroceStop",
      name: "订单强停",
      component: orderFroceStop,
      meta: {
        title: "订单强停",
        keepAlive: true
      }
    },
    {
      path: "/selfService/orderFroceStopDetail",
      name: "订单强停详情",
      component: orderFroceStopDetail,
      meta: {
        title: "订单强停",
        keepAlive: true
      }
    },
    {
      path: "/selfService/parkingFeeAppeal",
      name: "停车费申诉",
      component: parkingFeeAppeal,
      meta: {
        title: "停车费申诉",
        keepAlive: true
      }
    },
    {
      path: "/selfService/parkingFeeAppealDetail",
      name: "停车费申诉详情",
      component: parkingFeeAppealDetail,
      meta: {
        title: "停车费申诉",
        keepAlive: true
      }
    },
    {
      path: "/selfService/parkingFeeAppealFeedback",
      name: "停车费申诉反馈",
      component: parkingFeeAppealFeedback,
      meta: {
        title: "申诉反馈",
        keepAlive: true
      }
    },
    {
      path: "/selfService/placeFeeAppeal",
      name: "占位费申诉",
      component: placeFeeAppeal,
      meta: {
        title: "占位费申诉",
        keepAlive: true
      }
    },
    {
      path: "/selfService/placeFeeAppealDetail",
      name: "占位费申诉详情",
      component: placeFeeAppealDetail,
      meta: {
        title: "占位费申诉",
        keepAlive: true
      }
    },
    {
      path: "/selfService/placeFeeAppealFeedback",
      name: "占位费申诉反馈",
      component: placeFeeAppealFeedback,
      meta: {
        title: "占位费申诉",
        keepAlive: true
      }
    },
    {
      path: "/selfService/workOrderProgress",
      name: "工单进度",
      component: workOrderProgress,
      meta: {
        title: "申诉进度",
        keepAlive: true
      }
    },
    {
      path: "/selfService/workOrderProgressDetail",
      name: "工单进度详情",
      component: workOrderProgressDetail,
      meta: {
        title: "申诉进度",
        keepAlive: true
      }
    },
    {
      path: "/selfService/orderListSelect",
      name: "选择订单列表",
      component: orderListSelect,
      meta: {
        title: "查看订单及优惠券信息",
        keepAlive: true
      }
    },
    {
      path: "/selfService/unableDrawGun",
      name: "无法拔枪",
      component: unableDrawGun,
      meta: {
        title: "无法拔枪",
        keepAlive: true
      }
    },
    {
      path: "/selfService/unableDrawGun/video",
      name: "无法拔枪视频",
      component: unableDrawGunVideo,
      meta: {
        title: "无法拔枪"
      }
    },
    {
      path: "/selfService/stationPrice",
      name: "充电费用",
      component: stationPrice,
      meta: {
        title: "充电费用"
      }
    },
    {
      path: "/selfService/parkingFeeDetail",
      name: "停车费详情",
      component: parkingFeeDetail,
      meta: {
        title: "停车费详情"
      }
    },
    {
      path: "/selfService/orderCouponDetail",
      name: "订单及优惠券信息",
      component: orderCouponDetail,
      meta: {
        title: "查看订单及优惠券信息",
        keepAlive: true
      }
    },
    {
      path: "/msgToApp",
      name: "打开App",
      component: msgToApp,
      meta: {
        title: "打开App" 
      }
    },
    {
      path: "/msgToWxMini",
      name: "开迈斯充电小程序",
      component: msgToWxMini,
      meta: {
        title: "开迈斯充电小程序" 
      }
    },
    {
      path: "/v1g/stub/info",
      name: "智能充电管家",
      component: v1gStubInfoNew,
      meta: {
        title: "智能充电管家"
      }
    },
    {
      path: "/msgToLink",
      name: "前往开迈斯充电",
      component: msgToLink,
      meta: {
        title: "前往开迈斯充电" 
      }
    },
    {
      path: "/invoice/rule",
      name: "开票规则",
      component: invoiceRule,
      meta: {
        title: "开票规则" 
      }
    },
    {
      path: "/firstChargeGift",
      name: "充电有礼",
      component: firstChargeGift,
      meta: {
        title: "充电有礼" 
      }
    },
    {
      path: "/monthStatics",
      name: "月度电量",
      component: monthStatics,
      meta: {
        title: "月度电量" 
      }
    },
    {
      path: "/v1g/order/detail",
      name: "调控订单详情",
      component: v1gOrderDetail,
      meta: {
        title: "调控订单详情" 
      }
    },
    {
      path: "/starStationDesc",
      name: "星级站描述",
      component: starStationDesc,
      meta: {
        title: "" 
      }
    },
    {
      path: "/newTechnologiesIntroduction",
      name: "新科技介绍",
      component: newTechnologiesIntroduction,
      meta: {
        title: "新科技介绍"
      }
    },
    {
      path: "/silentLockRelease",
      name: "无感降锁",
      component: silentLockRelease,
      meta: {
        title: "无感降锁"
      }
    },
    {
      path: "/accelerateCharge",
      name: "加速充",
      component: accelerateCharge,
      meta: {
        title: "加速充"
      }
    },
    {
      path: "/ninetyEightCharge",
      name: "98号电",
      component: ninetyEightCharge,
      meta: {
        title: "98号电"
      }
    },
    {
      path: "/accelerateStartup",
      name: "加速启动",
      component: accelerateStartup,
      meta: {
        title: "加速启动"
      }
    },
    {
      path: "/v2gDischarge",
      name: "V2G充放电",
      component: v2gDischarge,
      meta: {
        title: "V2G充放电"
      }
    },

  ],

  scrollBehavior(to, from, savedPosition) {
    console.log('route', JSON.stringify(to.query));
    if (savedPosition) {
      return savedPosition;
    } else {
      if (to.path == "/hpc/activity/info" || to.path == "/hpc/rank/info" || to.path == "/hpc/user/service") {
        return {
          x: 0,
          y: 0
        }
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js